import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Topeka = () => {
  const nearbyFacilities = [
    { name: 'Manufacturing Plants', type: 'Industrial', capacity: '100+ Facilities' },
    { name: 'Food Processing', type: 'Processing', capacity: '50+ Plants' },
    { name: 'Distribution Centers', type: 'Logistics', capacity: '75+ Centers' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Topeka manufacturing facilities?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Topeka manufacturing plants and industrial facilities. We provide 6-8 hour response times with competitive pricing for the Kansas capital region."
    },
    {
      question: "What types of equipment do you buy from Topeka facilities?",
      answer: "We buy industrial process equipment, control valves, instrumentation, and manufacturing equipment from Topeka's manufacturing plants, food processing facilities, and distribution centers. We understand the requirements of diverse industrial operations."
    },
    {
      question: "How quickly can you respond to Topeka facilities?",
      answer: "We provide 6-8 hour response times for Topeka and surrounding Kansas facilities. Our team has 25+ years of experience serving Topeka's industrial base including manufacturing, food processing, and distribution operations."
    },
    {
      question: "Do you purchase equipment from Topeka food processing plants?",
      answer: "Yes, we buy process equipment and instrumentation from Topeka's food processing facilities. We provide professional valuations for food-grade equipment and control systems."
    },
    {
      question: "What valve brands do you buy from Topeka facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Topeka manufacturing plants, food processing facilities, and industrial operations."
    },
    {
      question: "Do you buy equipment during Topeka facility shutdowns?",
      answer: "Yes, we provide shutdown coordination for Topeka facilities. We can quickly evaluate and purchase surplus equipment during planned maintenance and facility upgrades."
    }
  ];

  useEffect(() => {
    // Set page title
    document.title = "We Buy Valves Topeka | Industrial Equipment Buyers Topeka Kansas";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Topeka Kansas - Professional valve buyers serving Kansas capital region industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'We buy valves Topeka Kansas - Professional valve buyers serving Kansas capital region industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'we buy valves topeka, valve buyers Topeka, manufacturing equipment Kansas, surplus valves, Fisher control valves, industrial equipment');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'we buy valves topeka, valve buyers Topeka, manufacturing equipment Kansas, surplus valves, Fisher control valves, industrial equipment';
      document.head.appendChild(meta);
    }

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/topeka');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Topeka | Industrial Equipment Buyers Topeka Kansas' },
      { property: 'og:description', content: 'We buy valves Topeka Kansas - Professional valve buyers serving Kansas capital region industrial facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/topeka' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '39.0558;-95.6890' },
      { name: 'geo.placename', content: 'Topeka, Kansas' },
      { name: 'geo.region', content: 'US-KS' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/topeka",
          "url": "https://valvesalessupply.com/topeka",
          "name": "We Buy Valves Topeka | Industrial Equipment Buyers Topeka Kansas",
          "description": "We buy valves Topeka Kansas - Professional valve buyers serving Kansas capital region industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Kansas",
                "item": "https://valvesalessupply.com/kansas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Topeka",
                "item": "https://valvesalessupply.com/topeka"
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Topeka",
          "image": "https://valvesalessupply.com/logo.png",
          "@id": "https://valvesalessupply.com/topeka",
          "url": "https://valvesalessupply.com/topeka",
          "telephone": "214-854-5638",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Topeka",
            "addressRegion": "KS",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 39.0558,
            "longitude": -95.6890
          },
          "areaServed": {
            "@type": "City",
            "name": "Topeka",
            "containedIn": {
              "@type": "State",
              "name": "Kansas"
            }
          },
          "serviceType": ["Industrial Valve Buyers", "Manufacturing Equipment Buyers", "Food Processing Equipment", "Distribution Equipment"]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(schemaData)) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/e8004eacdd4aaf3e32d7047b7db5a891.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Topeka</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional <strong>valve buyers in Topeka</strong> serving Kansas capital region industrial facilities. 
              Valve Sales Supply purchases surplus valves, control systems, and instrumentation from Topeka manufacturing 
              plants and processing facilities at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET TOPEKA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">TOPEKA INDUSTRIAL EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Topeka, as Kansas's capital city, hosts diverse manufacturing, food processing, and distribution operations. 
                As experienced <strong className="text-[#1B3A5F]">surplus valve buyers in Topeka</strong>, 
                we provide professional equipment purchasing services for all industrial sectors.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount transmitters, and complete instrumentation systems from Topeka industrial facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">100+</div>
                  <div className="text-gray-600">Manufacturing Plants</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-8 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">50+</div>
                  <div className="text-gray-600">Processing Plants</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">TOPEKA FACILITIES</h3>
              <div className="space-y-4">
                {nearbyFacilities.map((facility, index) => (
                  <div key={index} className="bg-white rounded-lg p-4">
                    <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                    <div className="flex justify-between mt-2">
                      <span className="text-gray-600 text-sm">{facility.type}</span>
                      <span className="text-[#1B3A5F] font-semibold text-sm">{facility.capacity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES TOPEKA KS</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Topeka industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Control Valves',
                equipment: ['Fisher Control Valves', 'Masoneilan Valves', 'Ball Valves', 'Gate Valves', 'Globe Valves'],
                description: 'Premium control valves from Topeka facilities'
              },
              {
                title: 'Process Equipment',
                equipment: ['Heat Exchangers', 'Pumps', 'Compressors', 'Safety Systems'],
                description: 'Industrial equipment from manufacturing plants'
              },
              {
                title: 'Instrumentation',
                equipment: ['Rosemount Transmitters', 'Flow Meters', 'Pressure Instruments', 'Controllers'],
                description: 'Process instrumentation from Kansas facilities'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{category.title}</h3>
                <p className="text-gray-600 mb-6">{category.description}</p>
                
                <div className="space-y-3">
                  {category.equipment.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-white rounded-3xl p-8">
            <h3 className="text-[#1B3A5F] text-2xl font-bold mb-8 text-center">WHY SELL VALVES TO US IN TOPEKA</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                { icon: 'ri-money-dollar-circle-line', title: 'Premium Pricing', desc: 'Above scrap rates for functional valves and instrumentation' },
                { icon: 'ri-time-line', title: 'Quick Response', desc: '6-8 hour response time throughout Topeka region' },
                { icon: 'ri-shield-check-line', title: 'Full Compliance', desc: 'Complete documentation and regulatory compliance' },
                { icon: 'ri-truck-line', title: 'Professional Service', desc: 'Expert equipment removal and logistics' },
                { icon: 'ri-award-line', title: 'Proven Experience', desc: '25+ years serving Kansas industrial facilities' },
                { icon: 'ri-customer-service-line', title: 'Direct Communication', desc: 'Work directly with experienced buyers' }
              ].map((benefit, index) => (
                <div key={index} className="flex flex-col items-center text-center">
                  <i className={`${benefit.icon} text-[#1B3A5F] text-4xl mb-3`}></i>
                  <h4 className="text-[#1B3A5F] font-bold mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 text-sm">{benefit.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">RELATED KANSAS MARKETS</h2>
            <p className="text-gray-600 text-xl">We serve all major Kansas industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { city: 'Wichita', link: '/wichita' },
              { city: 'Kansas City', link: '/kansas-city' },
              { city: 'Tulsa', link: '/tulsa', state: 'OK' }
            ].map((market, index) => (
              <Link
                key={index}
                to={market.link}
                className="bg-[#F5F7FA] rounded-xl p-6 text-center hover:shadow-lg hover:bg-white transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
              >
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{market.city}</h3>
                <div className="text-gray-600 text-sm mb-3">{market.state || 'KS'} Valve Buyers</div>
                <div className="text-[#1B3A5F] font-semibold inline-flex items-center">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/kansas"
              className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center text-lg"
            >
              View All Kansas Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">TOPEKA EQUIPMENT BUYER</h2>
              <p className="text-xl text-gray-200 mb-8">
                Contact Mark Driver for professional equipment purchasing services in Topeka
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold text-xl">214-854-5638</div>
                    <div className="text-gray-300">Direct Line - Mark Driver</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold">topeka@valvesalessupply.com</div>
                    <div className="text-gray-300">Equipment Lists & Photos</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WHY CHOOSE VALVE SALES SUPPLY</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast 6-8 hour response in Topeka',
                  'Expert knowledge of industrial equipment',
                  'Professional shutdown coordination',
                  'Complete compliance documentation',
                  '25+ years Kansas market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] text-xl mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center w-full whitespace-nowrap"
                >
                  GET QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">TOPEKA VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Topeka;
